
<h1 mat-dialog-title> {{isNewOffer ? "Créer nouvelle offre"  : "Mettre à jour offre" }}</h1>
<!-- car: {{providerOffer.carId}}, <br />
offer: {{providerOffer.offerId}}, <br />
line: {{providerOffer.businessLine}} <br />
d line: {{data.businessLine}} -->
<div mat-dialog-content>
  <form #offerEditForm="ngForm" class="offer-edit-form">
    <div hidden>
      <mat-form-field >
        <input type="text" matNativeControl matInput="" name ="id" placeholder="Id"  [(ngModel)] = "providerOffer.offerId" >
      </mat-form-field>
    </div >

    @if (providerOffer.carId === '') {
      <span>
        <mat-form-field >
          <mat-label>Marque</mat-label>
          <mat-select required name = "make" (selectionChange)="onMakeChange($event.value)" [(ngModel)]="selectedMake">
            @for (make of (makes$ | async)!; track make; let i = $index) {
              <mat-option [value]="make" >{{make.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        @if (providerOffer.make !='') {
          <mat-form-field >
            <mat-label>Modele</mat-label>
            <mat-select matNativeControl required name = "model" [disabled]="!(selectedMake.id>0)" (selectionChange)="onModelChange($event.value)" [(ngModel)]="selectedModel">
              @for (model of (models$ | async)!; track model) {
                <mat-option [value]="model"> {{model.makeName}}  {{model.name}} </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        @if (providerOffer.make !='') {
          <mat-form-field >
            <mat-label>Version</mat-label>
            <mat-select matNativeControl required name = "version" [disabled]="!(selectedModel.id>0)" (selectionChange)="onVersionChange($event.value)" [(ngModel)]="selectedVersion">
              @for (version of (versions$ | async)!; track version) {
                <mat-option [value]="version"> {{version.makeName}}  {{version.modelName}}  {{version.name}} </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        @if (providerOffer.version !='') {
          <mat-form-field >
            <mat-label>Motorisation</mat-label>
            <mat-select matNativeControl required name = "engine" [disabled]="!(selectedVersion.id>0)" (selectionChange)="onEngineChange($event.value)" [(ngModel)]="selectedEngine">
              @for (engine of selectedVersion.engines; track engine) {
                <mat-option [value]="engine"> {{engine.id}} - {{engine.ref}}  {{engine.name}}  {{engine.powerHp}} CV </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        @if (providerOffer.version!='') {
          <mat-form-field>
            <mat-label>Features</mat-label>
            <mat-select multiple matNativeControl name = "features" [(ngModel)] = "providerOffer.features">
              @for (feature of ( features$ | async)!; track feature) {
                <mat-option [value]="feature.name"> {{feature.code}} - {{feature.name}} </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        <!-- <mat-form-field *ngIf = "providerOffer.model !=''" >
        <mat-label>Body Type</mat-label>
        <mat-select matNativeControl  required name = "bodyType" [(ngModel)] = "providerOffer.bodyType">
          <mat-option *ngFor="let t of carBodyTypes;" [value]="t"> {{t}} </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field *ngIf="providerOffer.model!=''">
        <mat-label>Année</mat-label>
        <input type="number" matInput="" name ="year" placeholder="First Registration"  [(ngModel)] = "providerOffer.year" >
      </mat-form-field>
      -->
      @if (providerOffer.model!='') {
        <mat-form-field>
          <mat-label >Carburant</mat-label>
          <mat-select required  name="fuel"  [(ngModel)]="providerOffer.fuel" >
            @for (fuel of carFuels; track fuel; let i = $index) {
              <mat-option [value]="fuel" >{{fuel}}</mat-option>
            }
          </mat-select>
          <!-- <mat-radio-group
          aria-labelledby="example-radio-group-label" required class="example-radio-group" name="fuel" [(ngModel)] = "providerOffer.fuel">
          <mat-radio-button class="example-radio-button" *ngFor="let f of carFuels; index as i"  [value]="f">
            {{f}}
          </mat-radio-button>
        </mat-radio-group> -->
      </mat-form-field>
    }
    @if (providerOffer.fuel.valueOf() !='' ) {
      <mat-form-field>
        <mat-label>Boite</mat-label>
        <mat-select required  name="gearbox"  [(ngModel)]="providerOffer.gearBox" >
          @for (gear of carGearBoxes; track gear; let i = $index) {
            <mat-option [value]="gear" >{{gear}}</mat-option>
          }
        </mat-select>
        <!-- <mat-radio-group
        aria-labelledby="example-radio-group-label" class="example-radio-group" name="gearbox" [(ngModel)] = "providerOffer.gearbox">
        <mat-radio-button class="example-radio-button" *ngFor="let g of carGearBoxes; index as i"  [value]="g">
          {{g}}
        </mat-radio-button>
      </mat-radio-group> -->
    </mat-form-field>
  }
  @if (providerOffer.gearBox.valueOf() != '') {
    <mat-form-field>
      <mat-label>Année</mat-label>
      <mat-select matNativeControl required name = "year" [(ngModel)] = "providerOffer.year">
        @for (year of carYearsBD; track year) {
          <mat-option [value]="year"> {{year}} </mat-option>
        }
      </mat-select>
    </mat-form-field>
  }
  @if (providerOffer.year > 0) {
    <mat-form-field>
      <mat-label>Kilometrage</mat-label>
      <input type="number" required matInput="" name ="mileage" step="1000" placeholder="mileage"  [(ngModel)] = "providerOffer.mileage" >
    </mat-form-field>
  }
</span>
}
<mat-form-field>
  <mat-label>Pays</mat-label>
  <mat-select required  name="country" (selectionChange)="updateCitiesBD(providerOffer.country);" [(ngModel)]="providerOffer.country" >
    @for (country of countryCodeOptions; track country; let i = $index) {
      <mat-option [value]="country" >{{getCountry(country).name}}</mat-option>
    }
  </mat-select>
</mat-form-field>

<mat-form-field>
  <mat-label>Ville </mat-label>
  <mat-select matNativeControl [disabled]="providerOffer.country===''" required name = "city" [(ngModel)]="providerOffer.city">
    @for (city of citiesBD; track city; let i = $index) {
      <mat-option [value]="city"> {{getCity(city)}} </mat-option>
    }
  </mat-select>
</mat-form-field>

<mat-form-field required>
  <mat-label>Titre</mat-label>
  <input type="text" matInput="" name ="offerTitle" placeholder="Titre"  [(ngModel)] = "providerOffer.offerTitle" >
</mat-form-field>

<mat-form-field required>
  <mat-label >Description</mat-label>
  <textarea matInput type="text" name ="offerDescription" placeholder="Description"  [(ngModel)]="providerOffer.offerDescription" ></textarea>
</mat-form-field>

@if (providerOffer.businessLine === CarBusinessLine.BUY) {
  <mat-form-field>
    <mat-label>Prix vente ({{providerOffer.buyPrice.currency}}) </mat-label>
    <input type="number" required minlength=3 matInput="" name ="buyPrice" step="1000" placeholder="Prix vente"  [(ngModel)]="providerOffer.buyPrice.amount" >
  </mat-form-field>
}

@if (providerOffer.businessLine === CarBusinessLine.RENT) {
  <mat-form-field>
    <mat-label>Tarif journalier ({{providerOffer.rentDayRate.currency}}/J)</mat-label>
    <input type="number" required matInput="" name ="rentDayRate" step="1000" placeholder="Tarif journalier"  [(ngModel)]="providerOffer.rentDayRate.amount" >
  </mat-form-field>
}

@if (providerOffer.businessLine === CarBusinessLine.RENT) {
  <mat-form-field>
    <mat-label>Chauffeur ({{providerOffer.rentDriverDayRate.currency}}/J)</mat-label>
    <input type="number" required matInput="" name ="driverDayRate" step="1000" placeholder="Chauffeur"  [(ngModel)]="providerOffer.rentDriverDayRate.amount" >
  </mat-form-field>
}

@if (providerOffer.businessLine === CarBusinessLine.RENT) {
  <mat-form-field>
    <mat-label>Assurance ({{providerOffer.rentInsuranceDayRate.currency}}/J)</mat-label>
    <input type="number" required matInput="" name ="insuranceDayRate" step="1000" placeholder="Assurance"  [(ngModel)]="providerOffer.rentInsuranceDayRate.amount" >
  </mat-form-field>
}


<!--
<mat-form-field *ngIf = "providerOffer.model !=''">
  <input type="text" matInput="" name ="variant" placeholder="Variant"  [(ngModel)] = "providerOffer.variant" >
</mat-form-field>

<mat-form-field *ngIf = "providerOffer.id !=''">
  <input type="text" matInput="" name ="id" placeholder="Id"  [(ngModel)] = "providerOffer.id" >
</mat-form-field>


<p *ngIf = "updateMode">
  <label id="example-radio-group-label">Body Type</label>
  <br />
  <mat-radio-group
    aria-labelledby="example-radio-group-label" class="example-radio-group" name="bodyType" [(ngModel)] = "providerOffer.bodyType">
    <mat-radio-button class="example-radio-button" *ngFor="let type of carBodyTypes; index as i"  [value]="type">
      {{type}}
    </mat-radio-button>
  </mat-radio-group>

</p>


<p style="color: orange">{{ formMessage }} </p>
-->

<!--
<p> {{!updateMode ? "Create new providerOffer"  : "Update providerOffer Infos" }}
  <button (click) = "toggleMode()" class="link" >{{updateMode ? "Show body type"  : "Hide body type" }}</button>

</p>
-->

</form>

<div class="action-buttons">
  <button class="simple-button-buy" mat-button [mat-dialog-close]="">Annuler</button>
  <button class="cta-button-buy" [disabled]=!offerEditForm.valid mat-button [mat-dialog-close]="providerOffer" (click)="submitProviderOffer();$event.stopPropagation()">
    Enregistrer
  </button>
</div>

</div>
<!--
<div mat-dialog-actions>
  <button class ="simple-button" mat-button [mat-dialog-close]="">Annuler</button>
  <button class ="cta-button-{{providerOffer.businessLine.toLowerCase()}}" [disabled] = !offerEditForm.valid mat-button [mat-dialog-close]="providerOffer" cdkFocusInitial> {{isNewOffer ? "Créer"  : "Enregistrer " }} </button>
</div> -->



